import MainLoader from './MainLoader'

export default MainLoader
// eslint-disable-next-line import/export
export * from './MainLoader'
